<template>
  <div class="form-group" v-bind:class="{ 'has-error': error }">
    <label v-if="label" :for="name">{{ label }}</label>
    <select type="text"
            @change="updateValue($event.target.value)"
            :name="name"
            :required="required"
            :disabled="disabled"
            class="form-control"
            autocomplete="address-level2"
    >
      <option v-if="placeholder" value="">{{ placeholder }}</option>
      <option v-if="Array.isArray(cities)"
              v-for="city in cities"
              :value="city.id"
              :selected="value == city.id"
      >
        {{ city.name }}
      </option>
    </select>
    <span v-if="error" class="help-block" v-html="error"></span>
  </div>
</template>

<script>
  export default{
    name: 'InputCities',
    props: ['name', 'value', 'state', 'required', 'label', 'error', 'disabled'],
    data () {
      return {
        placeholder: '- -'
      }
    },
    methods: {
      updateValue (value) {
        this.stateId = value
        this.$emit('input', value)
      },
      getCities () {
        if (this.stateId) {
          this.placeholder = 'Carregando...'
          return this.$http.get('cities?state_id=' + this.stateId)
          .then((response) => {
            this.placeholder = 'Selecione'
            return response.data.data
          }, () => false)
        } else {
          return new Promise(() => false, () => false)
        }
      }
    },
    watch: {
      stateId (value) {
        this.cities = false
        this.cities = this.getCities()
      }
    },
    computed: {
      stateId () {
        return this.state
      }
    },
    asyncComputed: {
      cities: {
        get () {
          return this.getCities()
        },
        default: false
      }
    }
  }
</script>


// WEBPACK FOOTER //
// InputCities.vue?897cc348